import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { RootState } from '../../../../store';
import { receiptsViewInit } from '../receiptsViewSlice';
import { routingOnRouteToReceipts } from 'src/app/store/routingSlice';

type IN = ReturnType<typeof routingOnRouteToReceipts>;
type OUT = ReturnType<typeof receiptsViewInit>;

export const ReceiptsViewOnRouteEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(routingOnRouteToReceipts.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return [receiptsViewInit()];
    }),
  );
